// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import values from "./data/github-copilot.json" with { type: "json" };
import { flattenModelCatalog, type ModelCatalog } from "../model-catalog.ts";

export const GITHUB_COPILOT_MODELS: ModelCatalog<typeof values, "github-copilot"> =
	flattenModelCatalog("github-copilot", values);
